<template>
  <span>
    <Button class="ubtn_icon" shape="circle" size="small" @click="open"
      >医术咨询/预备方案</Button
    >
    <Modal
      v-model="showWin"
      title="医术咨询/预备方案"
      width="900"
      class-name="medicalConsultationInformation"
      footer-hide
    >
      <div class="">
        <div class="patient-info">
          <span class="patient-name">{{ info.patientName }}</span>
          <span class="patient-gender">{{ info.sex }}</span>
          <span class="patient-age">{{ info.patientAge }}岁</span>
          <span>{{ info.cellphoneNo }}</span>
        </div>
        <div class="body">
          <div class="left">
            <utabs
              :list="typeList"
              v-model="expertiseType"
              type="utabs-type1"
              @change="getData"
            />
            <div class="header">
              <div class="bz">病种</div>
              <div class="zx">
                {{ expertiseType == 3 ? "咨询医生" : "医生" }}
              </div>
              <div class="bzjys" v-if="expertiseType == 3">被咨询医生</div>
              <div class="sj"></div>
            </div>
            <div class="list" v-if="list.length">
              <div
                v-for="(item, index) in list"
                class="item"
                :class="{ active: item == activeItem }"
                :key="index"
                @click="activeItem = item"
              >
                <div class="bz">{{ item.diseaseName }}</div>
                <div
                  class="zx"
                  :class="{ red: item.doctorId == userInfo.husDoctorId }"
                >
                  {{ item.doctorName }}
                </div>
                <div class="bzjys" v-if="expertiseType == 3">
                  {{ item.benchmarkDoctorName }}
                </div>
                <div class="js">{{ formatDate(item.consultDate) }}</div>
              </div>
            </div>
            <empty v-else />
          </div>
          <div class="right">
            <messageBox
              v-if="activeItem"
              ref="messageBoxRef"
              :info="activeItem"
              :isLook="true"
            />
            <empty v-else />
          </div>
        </div>
      </div>
    </Modal>
  </span>
</template>

<script>
import request from "@/utils/request";
import dayjs from "dayjs";
import { mapGetters } from "vuex";
export default {
  props: {
    info: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      expertiseType: 3,
      showWin: false,
      pageIndex: 1,
      pageSize: 1000,
      list: [],
      activeItem: null,
      typeList: [
        {
          label: "咨询方案",
          value: 3,
        },
        {
          label: "预备方案",
          value: 5,
        },
      ],
    };
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  components: {},
  methods: {
    formatDate(date) {
      return dayjs(date).format("MM-DD");
    },
    getData() {
      request
        .post("/zhbusiness/getYzMedicalExpertiseList", {
          expertiseType: this.expertiseType,
          patientCode: this.info.patientCode,
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
        })
        .then((res) => {
          this.list = res.result.map((i) => {
            i.expertiseType = this.expertiseType;
            return i;
          });
          if (this.list.length > 0) {
            this.activeItem = this.list[0];
          } else {
            this.activeItem = null;
          }
        });
    },
    init() {
      this.getData();
    },
    open() {
      this.init();
      this.showWin = true;
    },
  },
};
</script>

<style lang="scss" >
.medicalConsultationInformation {
  .utabs {
    padding: 5px 15px 0;
  }
  .ivu-modal-content {
    background: #fff;
    .ivu-modal-body {
      padding: 10px 0;
    }
  }
  .patient-info {
    border-bottom: 1px solid #ddd;
    padding: 0 15px 10px;

    font-size: 15px;
    & > span {
      margin-right: 15px;
    }
    .patient-name {
      font-size: 19px;
      font-weight: bold;
    }
  }
  .body {
    height: 400px;
    display: flex;
    .left {
      display: flex;
      flex-direction: column;
      height: 100%;
      width: 320px;
      flex-shrink: 0;
      border-right: 1px solid #ddd;

      .item {
        cursor: pointer;
      }

      .item,
      .header {
        padding: 0 15px;
        display: flex;
        line-height: 34px;
        & > div {
          flex: 1;
        }
        &.active {
          background: #f5f5f5;
        }
      }
      .list {
        height: 100%;
        overflow-y: auto;
      }
      .header {
        color: #999;
      }
    }
    .right {
      width: 100%;
    }
  }
}
</style>